<template>

    <el-container class="Main" >

         <el-header>
            <Header></Header>
          </el-header>


    <el-container>
      <el-aside width="225px">
        <Aside></Aside>
      </el-aside>
       <el-main>

          <el-tabs
          class="ElTab"
          v-model="editableTabsValue"
          type="card"
          closable
          @tab-remove="removeTab" >
            <el-tab-pane
              v-for="(item,index) in editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name">
              <div slot="label" @click="tabShowData(item.components,item.name)"  style="display: inline-block;">
                {{item.title}}
              </div>

                <router-view/>

                <!-- <component  v-bind:is="item.components"/> -->

                 <!-- <router-view name="/CheckDataDetail" /> -->
            </el-tab-pane>
          </el-tabs>

          </el-main>


         </el-container>
     </el-container>


</template>

<script>
  import Wait_Apply from "./Wait/Wait_Apply.vue"
  import Finaish from "./Wait/Finaish.vue"
  import Wait_Deal from "./Wait/Wait_Deal.vue"
  import Copy from "./Wait/Copy.vue"
  //主页界面
  // import Index from "./Index.vue"
  import YIndex from "./YIndex.vue"

  // 工具（拼接）页面link
  import Header from "./Tool/Header.vue"
  import Aside from "./Tool/Aside.vue"



  // 设置页面link
  import User from "./Munber/User.vue"
  import Place from "./Munber/Place.vue"
  import Unit from "./Munber/Unit.vue"
  import Department from "./Munber/Department.vue"
  import Log from "./Munber/Log.vue"
  import Category from "./Munber/Category.vue"

  // 资产页面link
  import Property_Index from "./Property/Property_Index.vue"
  import Property_Data from "./Property/Property_Data.vue"
  import Property_Insert from "./Property/Property_Insert.vue"
  import Property_Insert_More from "./Property/Property_Insert_More.vue"
  import Property_Insert_Data from "./Property/Property_Insert_Data.vue"
  import Property_Get from "./Property/Property_Get.vue"
  import Property_Borrow from "./Property/Property_Borrow.vue"
  import Property_Change from "./Property/Property_Change.vue"
  import Property_DiaoBo from "./Property/Property_DiaoBo.vue"
  import Property_Deal from "./Property/Property_Deal.vue"
  import Property_Maintenance from "./Property/Property_Maintenance.vue"
  import Property_Insert_Record from "./Property/Property_Insert_Record.vue"
  import Property_MyChange from "./Property/Property_MyChange.vue"
  import Property_Back from "./Property/Property_Back.vue"
  // import Property_Use from "./Property/Property_Use.vue"
  // import Property_Examine from "./Property/Property_Examine.vue"

  // 资产盘点页面
  import CheckData from "./Check/CheckData.vue"
  import CheckMission from "./Check/CheckMission.vue"
  import CheckSetting from "./Check/CheckSetting.vue"
  import CheckCreateNew from "./Check/CheckCreateNew.vue"
  import CheckIndex from "./Check/CheckIndex.vue"
  import CheckErrorData from "./Check/CheckErrorData.vue"
  import CheckWaitErrorData from "./Check/CheckWaitErrorData.vue"

  // 资产清查页面
  import DetectIndex from "./Detect/DetectIndex.vue"
  import DetectCreate from "./Detect/DetectCreate.vue"
  import DetectAllDataDetail from "./Detect/DetectAllDataDetail.vue"


   export default {
      name: 'Wait_Index',
        components: {
          Property_Index,
          Property_Data,
          Property_Insert,
          Property_Insert_More,
          Property_Insert_Data,
          Property_Get,
          Property_Borrow,
          Property_Change,
          Property_DiaoBo,
          Property_Deal,
          Property_Maintenance,
          Property_MyChange,
          Property_Insert_Record,
          Property_Back,
          // Property_Use,

          CheckData,
          CheckMission,
          CheckSetting,
          CheckCreateNew,
          CheckIndex,
          CheckErrorData,
          CheckWaitErrorData,

          DetectIndex,
          DetectCreate,
          DetectAllDataDetail,


          YIndex,
          // Index,
          Log,
          User,
          Category,
          Place,
          Unit,
          Department,
          Header,
          Aside,
          Wait_Apply,
          Finaish,
          Wait_Deal,
          Copy
        },
      data () {

        return {
          departmentId:'',
          PageData:'',
          components:'',
          nowPage: "Wait_Apply",
          editableTabsValue: 1,
          editableTabs: [
              {
                title: '主页',
                name: "1",
                content: 'Tab 1 content',
                components: '/index'
              }],

          tabIndex: 2,
          routerURL:'',
          isCollapse: true,
        }
      },
      watch:{
       $route(to,from){
         this.routerURL = to.path
       }
      },
      created:function() {
        window.addEventListener('popstate',this.delete,false)

        if(sessionStorage.getItem("status") == null){
          this.editableTabsValue = "1";
        }
        if(sessionStorage.getItem("status")!=null){
          this.editableTabs =  JSON.parse(sessionStorage.getItem("Data"))
          this.editableTabsValue = sessionStorage.getItem("status")
        }

      },

      methods: {

        PropertyShow(targetName,components,val) {
          this.departmentId = val
          this.addTab(targetName,components)
        },
      tabShowData(components,name){
         this.editableTabsValue = name
         this.$router.replace(components)
         sessionStorage.setItem("Data",JSON.stringify(this.editableTabs))
         sessionStorage.setItem("status",this.editableTabsValue)
      },

          addTab(targetName,components) {
            let newTaName = null;
            if(sessionStorage.getItem("tabIndex")!=null){
              this.tabIndex = sessionStorage.getItem("tabIndex")
              newTaName = ++this.tabIndex + '';
            }else{
              newTaName = ++this.tabIndex + '';
            }
            sessionStorage.setItem("tabIndex",newTaName)
            var c = 0;
              for(let a of this.editableTabs){
              if(a.components == components){
               c=123
               this.$router.replace(components)
              }
            }
            if(c!=123){
              this.editableTabs.push({
                title: targetName,
                name: newTaName,
                content: 'Tab 2 content',
                components:components
              });
              this.editableTabsValue = newTaName;
              this.$router.push(components)
              sessionStorage.setItem("Data",JSON.stringify(this.editableTabs))
              sessionStorage.setItem("status",this.editableTabsValue)

              return
            }else{
              for(let a of this.editableTabs){
                if(a.components == components){
                  this.editableTabsValue = a.name
                  sessionStorage.setItem("status",this.editableTabsValue)
                }

              }
            }
          },
            delete(){
              let tabs = this.editableTabs;
              var num =1
              for(let i of tabs){
                num++;
                if(i.components == this.routerURL){
                  this.editableTabs.splice(num,1);

                }

              }
            },

          removeTab(targetName) {
                 let tabs = this.editableTabs;
                 let activeName = this.editableTabsValue;
                 if (activeName == targetName) {
                   tabs.forEach((tab, index) => {
                     if (tab.name === targetName) {
                       let nextTab = tabs[index + 1] || tabs[index - 1];
                       if (nextTab) {
                         activeName = nextTab.name;
                         this.tabShowData(nextTab.components)

                       }
                     }
                   });
                 }
                 this.editableTabsValue = activeName;
                 this.editableTabs = tabs.filter(tab => tab.name !== targetName);
                 sessionStorage.setItem("status",this.editableTabsValue)
                 sessionStorage.setItem("Data",JSON.stringify(this.editableTabs))
               },
      }
    }
</script>

<style scoped>
  .Main{
    height: 1100px;
    background-color: #ffffff;

  }
  .el-aside::-webkit-scrollbar {
     display: none;
  }
  .el-header {
    text-align: center;

  }

  .el-aside {
   /* background-color: #E9EEF3; */
    background-color: #4285F4;
    text-align: center;

  }

  .el-main {
    margin: 0px;
/*    background-color:	#F0F0F0; */
    background-color: rgb(240,240,240);
/*    color:rgb(0,0,0)
    255 240 240 240 */
    text-align: center;
    min-width: 1700px;
  }
  .ElTab{
     border-radius: 10px;
     /* background-color: white; */
     /* min-height: 1000px; */
  }



</style>



// WEBPACK FOOTER //
// src/components/Wait_Index.vue